import React, { useEffect, useState } from 'react';
import { DI, DIProps } from '../../../../Core';
import { useTranslation } from 'react-i18next';
import { Box, BlockStack, InlineStack, Icon, Divider, Button, Text, Badge, Tooltip } from '@shopify/polaris';
import { StatusActiveMajor } from '@shopify/polaris-icons';
import { CustomInfoIcon } from '../../../../Asests/svgIcon/icon';
import { MarketingGridSkelton } from '../skeleton/PricingSkeleton';

interface Props extends DIProps { }
// Define a custom order
const customOrder = ["enhanced_support", "premium_support", "elite_support"];
function Marketing_offerCard(props: Props) {
    const { t } = useTranslation();
    const [monthlyPlans, setMonthlyPlans] = useState<any[]>([]);

    useEffect(() => {
        let obj: any = { category: "marketing_offer" };

        props.di.GET('plan/plan/get', obj)
            .then((data: any) => {
                if (data.success) {
                    let allPlans = data?.data?.data?.rows || [];
                    let extractedPlans = Object.values(allPlans).map((plan: any) => plan?.monthly);


                    // Sort extracted plans based on custom order
                    extractedPlans.sort((a: any, b: any) => {
                        return customOrder.indexOf(a.code) - customOrder.indexOf(b.code);
                    });
                    setMonthlyPlans(extractedPlans);
                } else {
                    props.error(t(data.message));
                }
            })
            .catch((error: any) => {
                console.error("Error fetching plans:", error);
            });
    }, []); // Dependencies added to prevent unnecessary re-renders


    const highligtedCard = ((plan: any) => {
        if (plan?.badge) {
            return true;
        } else {
            return false;
        }
    })

    if (monthlyPlans.length > 0) {
        return (
            <>
                {monthlyPlans.map((monthlyPlan: any, index: number) => (

                    <div className='Custom-radius-12 custom-support-offer__card' key={index}>
                        <Box background={monthlyPlan?.badge ? 'bg-inverse' : 'bg-surface-selected'} padding={"500"} borderRadius='300'>
                            <BlockStack gap={"500"} align='space-between'>
                                <BlockStack gap={"400"}>
                                    <BlockStack gap={"050"}>
                                        <InlineStack gap={"200"} align='space-between'>
                                            <Text tone={monthlyPlan?.badge ? 'text-inverse' : undefined} as='span' variant='headingMd'>
                                                <span className='fs-16'>{t(monthlyPlan?.title)}</span>
                                            </Text>
                                            {monthlyPlan?.badge && <Badge tone='warning-strong'>{t(monthlyPlan?.badge)}</Badge>}
                                        </InlineStack>

                                        <Text as='p' variant='bodyMd' tone={monthlyPlan?.badge ? 'text-inverse' : 'subdued'}>
                                            {t(monthlyPlan?.tagline)}
                                        </Text>
                                    </BlockStack>
                                    <Divider borderColor={monthlyPlan?.badge ? 'border-inverse' : 'border-brand'} />
                                    <BlockStack inlineAlign='start' gap={"200"}>
                                        {monthlyPlan?.features?.map((feature: any, ind: any) => (
                                            <InlineStack gap={"200"} key={ind} wrap={false} blockAlign='start'>
                                                <span><Icon source={StatusActiveMajor} tone="success" /></span>
                                                {feature?.description ? (
                                                    <InlineStack gap={"050"}>
                                                        <Text tone={monthlyPlan?.badge ? 'text-inverse' : undefined} as="p" variant="bodyMd">
                                                            {t(feature.feature)}
                                                            <Tooltip content={t(feature?.description)}>
                                                                <span className='custom-icon-with-text'>
                                                                    <CustomInfoIcon color={monthlyPlan?.badge ? "#E3E3E3" : "#4A4A4A"} />
                                                                </span>
                                                            </Tooltip>
                                                        </Text>
                                                    </InlineStack>
                                                ) : (
                                                    <Text tone={monthlyPlan?.badge ? 'text-inverse' : undefined} as="p" variant="bodyMd" fontWeight={"regular"}>
                                                        {t(feature.feature)}
                                                    </Text>
                                                )}
                                            </InlineStack>
                                        ))}
                                    </BlockStack>
                                </BlockStack>
                                <Button onClick={() => window.open("https://calendar.google.com/calendar/u/0/appointments/schedules/AcZssZ0g7NeU-DtavtyOoK6p_Vz_yix_xRdVCebaqHDOmQSxNt1J2_vO5ZaeqC_oDURH15RoA2-LGV2M", '_blank')} size='large'>{t("Contact Us")}</Button>
                            </BlockStack>
                        </Box>
                    </div>
                ))}
            </>
        );
    }
    else {
        return <MarketingGridSkelton />
    }
}

export default DI(Marketing_offerCard);
